import React, { FC } from 'react';
import {
  SidebarExpandableMenuItem,
  SidebarExpandableMenuItemProps,
} from '@saucelabs/ds-navigation';
import { recordTrack } from '@saucelabs/sl-util-segmentio';

import { labelToQA } from '../../utils';

export const TrackingSidebarExpandableMenuItem: FC<TrackingSidebarExpandableMenuItemProps> = ({
  label,
  navigationEvent,
  ...other
}) => (
  <SidebarExpandableMenuItem
    data-qa={labelToQA({ label, prefix: 'sidebar-item' })}
    label={label}
    onClick={() => {
      recordTrack(
        navigationEvent, {
          version: 'ds',
        },
      );
    }}
    {...other}
  />
);

export interface TrackingSidebarExpandableMenuItemProps extends SidebarExpandableMenuItemProps {
  navigationEvent: string;
}
